<template lang='pug'>
  v-container(fill-height)
    v-row
      v-col
        v-row
          v-col(align='center')
            h1.text-h4.blue-grey--text.text--darken-1 You were invited to join Bionic Metrics
            h1.text-subtitle-1.blue-grey--text.text--darken-2 Sign up below.
        v-row
          v-col(md='6' offset-md='3' sm='8' offset-sm='2')
            form#invitedSignUpForm(@submit.prevent='invitedSignUp')
              v-row
                v-col(cols='12' sm='6')
                  v-text-field(prepend-icon='person'
                    name='firstName'
                    required
                    v-model='user.firstName'
                    label='First Name')
                v-col(cols='12' sm='6')
                  v-text-field(name='lastName'
                    prepend-icon='keyboard_arrow_right'
                    required
                    v-model='user.lastName'
                    label='Last Name')
              v-text-field(label='Email'
                prepend-icon='email'
                v-model='user.email'
                disabled
                type='email'
                required)
              v-row
                v-col(cols='12' sm='6')
                  v-text-field(prepend-icon='lock'
                    label='Password'
                    v-model='user.password'
                    min='8'
                    :append-icon="hidePassword ? 'visibility' : 'visibility_off'"
                    @click:append='hidePassword = !hidePassword'
                    :type="hidePassword ? 'password' : 'text'"
                    required)
                v-col(cols='12' sm='6')
                  v-text-field(label='Confirm Password'
                    :prepend-icon="(user.password === user.confirmPassword) ? 'check' : 'keyboard_arrow_right'"
                    v-model='user.confirmPassword'
                    min='8'
                    :append-icon="hidePassword ? 'visibility' : 'visibility_off'"
                    @click:append='hidePassword = !hidePassword'
                    :type="hidePassword ? 'password' : 'text'"
                    required)
              v-row(justify='end')
                v-btn(color='primary'
                  :disabled='disableButton'
                  type='submit') Create Account
              v-row.ma-4
                v-col.text-center.text-body-2
                  | By creating an account, you accept Bionic Metric's
                  | &nbsp;
                  a(target='_blank', href='https://bionicmetrics.com/terms') Terms of Service
                  | &nbsp;and&nbsp;
                  a(target='_blank', href='https://bionicmetrics.com/privacy') Privacy Policy
</template>


<script>
import {mapActions} from 'vuex';
import External from '../api/external';
import Notifications from '../services/notification.service';

export default {
  name: 'Invited',
  props: ['token'],
  async mounted() {
    try {
      this.user = await External.getInvitedUser(this.token);
    } catch (error) {
      await Notifications.alert('That invitation link has expired or is invalid.');
      this.$router.push('/signin');
    }
  },
  methods: {
    async invitedSignUp() {
      if (this.user && this.user.password !== this.user.confirmPassword) {
        return Notifications.alert('Passwords do not match');
      }
      if (this.user.password.length < 8) {
        return Notifications.alert('Password must be at least 8 characters long');
      }
      try {
        this.user.token = this.token;
        const user = await External.invitationSignup(this.user);
        await this.setUser(user);
        Notifications.toast('Welcome to Bionic Metrics');
        return this.$router.push('/');
      } catch (error) {
        console.error(error);
        return Notifications.alert('There was a problem activating your account');
      }
    },
    ...mapActions({
      setUser: 'setUser'
    })
  },
  data() {
    return {
      disableButton: false,
      hidePassword: true,
      user: {
        firstName: null,
        lastName: null,
        email: null,
        username: null,
        password: null,
        confirmPassword: null
      }
    };
  }
};
</script>

<style scoped>

</style>
